const filterByStatus =
    (status, negate = false) =>
    items =>
        items && items.filter(item => (negate ? item.status !== status : item.status === status));

export default filterByStatus;
